import { ERROR_ORIGIN } from "clientState/GoogleIdentityProvider/GoogleTrackingErrorProvider/TrackingErrorComponent";

import type { ClickListenerType, RenderGoogleButtonType } from "./contract";
import { getTrackingComponentId } from "./TrackingGoogleButton/TrackingGoogleButton";

const clickListener: ClickListenerType = (trackOnClick, name): void => {
  const buttonTracking = document.getElementById(getTrackingComponentId(name));
  buttonTracking?.click();
  trackOnClick();
};

export const renderGoogleButton: RenderGoogleButtonType = (
  trackOnClick,
  width,
  name,
  elementId,
) => {
  try {
    window.google.accounts.id.renderButton(document.getElementById(elementId), {
      theme: "outline",
      size: "large",
      text: "continue_with",
      type: "standard",
      shape: "pill",
      logo_alignment: "left",
      width,
      state: name,
      click_listener: () => {
        clickListener(trackOnClick, name);
      },
    });
  } catch {
    document.getElementById(ERROR_ORIGIN.render_google_button)?.click();
  }
};

export const getGoogleButtonId = (name: string): string => {
  return `${name}-Id`;
};
